export const ROW_CONDITION_FIELD_LABEL = "Condition"
export const ROW_CONDITION_TOOLTIP = "Restrict a subset of data you want to validate"
